import { React, useState, useEffect, useLayoutEffect, useRef } from "react";
import "./Evaluation.scss";
import { Link, useHistory, useParams } from "react-router-dom";
import { propertyAssessment } from "../../../survey-templates/property-assessment.js";
import * as Survey from "survey-react";
import "survey-react/modern.css";
import db from "../../../api/mongodb";
import { defaultOptions1 } from "../../../config/loading-config.js";
// import Lottie from "react-lottie";

const EvaluationSubsections = ({ subsections, scrollFunction }) => {
  const renderedSubsections = subsections.map((subsection, index) => {
    return (
      <div key={index} onClick={() => scrollFunction(index)}>
        {subsection}
      </div>
    );
  });

  return <>{renderedSubsections}</>;
};

export default EvaluationSubsections;
